import React from 'react'
import { Alert, Platform, StyleSheet, View } from 'react-native'
import { useMutation, useQueryClient } from 'react-query'

import TitleGraphic from '../../../components/TitleGraphic'
import Screen from '../../../components/Screen'
import AppText from '../../../components/Text'
import colors from '../../../config/colors'
import { defaultStyles } from '../../../config/styles'
import Button from '../../../components/Button'
import BossLabel from '../../../components/boss/label/BossLabel'
import bossQuery from '../../../api/query/boss'
import ActivityIndicator from '../../../components/ActivityIndicator'
import { useNavigation } from '@react-navigation/native'
import { DrawerNavigationProp } from '@react-navigation/drawer'
import { AppStackParamList } from '../../../navigation/AppNavigator'

export default function ViewScreen({ route }) {
  const navigation = useNavigation<DrawerNavigationProp<AppStackParamList>>()
  const queryClient = useQueryClient()

  const ERROR_MESSAGE = ''

  const { isLoading, isSuccess, isError, data, refetch } = bossQuery.getBoss(
    route.params.bossId
  )

  const bossDeleteMutation = useMutation(bossQuery.deleteBoss, {
    onSuccess: () => {
      queryClient.invalidateQueries('bosses')
      queryClient.invalidateQueries(['boss', { bossId: data.id }])

      navigation.navigate('BOSS', {
        screen: 'Boss_List',
      })
    },
    onError: (error) => {
      alert('Failed to delete the BOSS Practice')
      console.log(error)
    },
  })

  return (
    <Screen style={defaultStyles.screen}>
      <TitleGraphic
        section="BOSS Practice"
        title="View BOSS Practice"
        graphic={require('../../../assets/lead-boss.jpg')}
      />

      <View style={defaultStyles.mainContainer}>
        <ActivityIndicator visible={isLoading} />
        {isError && (
          <>
            <AppText>Couldn't retrieve the boss practice.</AppText>
            <Button title="Retry" onPress={refetch} />
          </>
        )}

        {isSuccess && (
          <>
            <View style={styles.table}>
              <View style={[styles.rowBorder]}>
                <AppText style={styles.heading}>Boss Practice: </AppText>
                <AppText>{data.name}</AppText>
              </View>
              <View style={[styles.rowBorder]}>
                <BossLabel
                  letter="B"
                  circleColour={colors.blue}
                  label="Body posture"
                />
                <AppText style={styles.bossValue}>
                  {data.boss.body ?? ERROR_MESSAGE}
                </AppText>
              </View>
              <View style={[styles.rowBorder]}>
                <BossLabel
                  letter="O"
                  circleColour={colors.blue}
                  label="Oxygen - Breath Practice"
                />
                <AppText style={styles.bossValue}>
                  {data.boss.oxygen ?? ERROR_MESSAGE}
                </AppText>
              </View>
              <View style={styles.rowBorder}>
                <BossLabel
                  letter="S"
                  circleColour={colors.red}
                  label="Self-Talk for Energy"
                />
                <AppText style={styles.bossValue}>
                  {data.boss.selfEnergy ?? ERROR_MESSAGE}
                </AppText>
              </View>
              <View style={styles.rowBorder}>
                <BossLabel
                  letter="S"
                  circleColour={colors.green}
                  label="Self-Talk for Action"
                />
                <AppText style={styles.bossValue}>
                  {data.boss.selfAction ?? ERROR_MESSAGE}
                </AppText>
              </View>
            </View>
            <View style={styles.row}>
              <View style={styles.button}>
                <Button
                  title="Edit"
                  onPress={() => {
                    console.log('Edit', data)
                    navigation.navigate('BOSS', {
                      screen: 'Boss_Form',
                      params: {
                        bossPracticeId: data.id,
                      },
                    })
                  }}
                />
              </View>
              <View style={styles.button}>
                <Button
                  title="Duplicate"
                  onPress={() => {
                    navigation.navigate('BOSS', {
                      screen: 'Boss_Form',
                      params: {
                        bossPracticeId: data.id,
                        duplicate: true,
                      },
                    })
                  }}
                />
              </View>
              <View style={styles.button}>
                <Button
                  title="Delete"
                  onPress={() => {
                    if (Platform.OS === 'web') {
                      if (
                        confirm(
                          'Are you sure you want to delete this BOSS practice?'
                        )
                      ) {
                        bossDeleteMutation.mutate(data.id)
                      }
                    } else {
                      Alert.alert(
                        'Delete',
                        'Are you sure you want to delete this BOSS practice?',
                        [
                          {
                            text: 'Yes',
                            style: 'destructive',
                            onPress: () => {
                              bossDeleteMutation.mutate(data.id)
                            },
                          },
                          { text: 'No', style: 'cancel' },
                        ]
                      )
                    }
                  }}
                />
              </View>
            </View>
          </>
        )}
      </View>
    </Screen>
  )
}

const styles = StyleSheet.create({
  button: {
    width: '30%',
    marginRight: 10,
  },
  heading: {
    fontWeight: '700',
    minWidth: 150,
    marginBottom: 10,
  },
  icon: {
    fontWeight: '700',
    width: 40,
    height: 40,
    lineHeight: 40,
    borderRadius: 40,
    backgroundColor: colors.primary,
    color: '#fff',
    textAlign: 'center',
    marginRight: 10,
  },
  title: {
    fontWeight: '700',
    height: 40,
    lineHeight: 40,
  },
  table: {},
  row: {
    flexDirection: 'row',
    paddingVertical: 20,
  },
  rowBorder: {
    borderBottomColor: colors.light,
    borderBottomWidth: StyleSheet.hairlineWidth,
    paddingVertical: 20,
  },
  horizontalAlign: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bossValue: {
    marginTop: 10,
  },
})
